import { jsx as _jsx } from "react/jsx-runtime";
import { CareHomeOverview } from "../../organisms";
export const CareSearch = ({ shortlist, shortlistData, onMarkSecured, }) => {
    return (_jsx(CareHomeOverview, { shortlist: shortlist, shortlistData: shortlistData, onMarkSecured: onMarkSecured }));
};
CareSearch.displayName = 'CareSearch';
export default CareSearch;
